import {
    // FILE_UPLOAD,
    CREATE_SJFAPPLICANTS,
    RETRIEVE_SJFAPPLICANTS,
    RETRIEVESINGLE_SJFAPPLICANTS,
    UPDATE_SJFAPPLICANTS,
    DELETE_SJFAPPLICANTS,
} from "./type";
import SJFApplicants from "../service/sjfApplicants";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await SJFApplicants.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await SJFApplicants.create(data);
        dispatch({
            type: CREATE_SJFAPPLICANTS,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await SJFApplicants.fetchList(data);
        dispatch({
            type: RETRIEVE_SJFAPPLICANTS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await SJFApplicants.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_SJFAPPLICANTS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await SJFApplicants.update(data);
        dispatch({
            type: UPDATE_SJFAPPLICANTS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const changeStatus = (data) => async (dispatch) => {
    try {
        const res = await SJFApplicants.changeStatus(data);
        // dispatch({
        //     type: UPDATE_SJFAPPLICANTS,
        //     status: '',
        //     response: {},
        //     payload: res.data,
        // });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const trash = (data) => async (dispatch) => {
    try {
        const res = await SJFApplicants.trash(data);
        dispatch({
            type: DELETE_SJFAPPLICANTS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};